import type { Subscription } from "../models/subscription";

export const CHECKOUT_PLAN_IDS = {
	PREMIUM_MONTHLY: "PREMIUM_MONTHLY",
	PREMIUM_YEARLY: "PREMIUM_YEARLY",
	PLUS_MONTHLY: "PLUS_MONTHLY",
	PLUS_YEARLY: "PLUS_YEARLY",
	PREMIUM_LIFETIME: "PREMIUM_LIFETIME",
} as const;

export type CheckoutPlanId =
	(typeof CHECKOUT_PLAN_IDS)[keyof typeof CHECKOUT_PLAN_IDS];

export const CHECKOUT_ACKNOWLEDGMENT_CODES = {
	EU_UK_IMMEDIATE_SERVICE: "EU_UK_IMMEDIATE_SERVICE",
	LIFETIME_NO_TRIAL: "LIFETIME_NO_TRIAL",
	LIFETIME_NO_REFUNDS: "LIFETIME_NO_REFUNDS",
	LIFETIME_EXISTING_SUBSCRIPTION_CANCELLATION:
		"LIFETIME_EXISTING_SUBSCRIPTION_CANCELLATION",
} as const;

export type CheckoutAcknowledgmentCode =
	(typeof CHECKOUT_ACKNOWLEDGMENT_CODES)[keyof typeof CHECKOUT_ACKNOWLEDGMENT_CODES];

export interface CheckoutAcknowledgmentDefinition {
	code: CheckoutAcknowledgmentCode;
	version: string;
	text: string;
}

export interface CheckoutAcknowledgmentAct {
	code: CheckoutAcknowledgmentCode;
	version: string;
}

export interface CheckoutPlan {
	planId: CheckoutPlanId;
	name: string;
	description: string;
	features: string[];
	planTier: "PREMIUM" | "PLUS";
	interval: "MONTH" | "YEAR" | "LIFETIME";
	totalPrice: number;
	monthlyPrice?: number;
	isSubscription: boolean;
}

export interface CheckoutReview {
	plans: CheckoutPlan[];
	selectedPlanId: CheckoutPlanId;
	requiredAcknowledgments: CheckoutAcknowledgmentDefinition[];
	acknowledgmentsByPlan: Record<
		CheckoutPlanId,
		CheckoutAcknowledgmentDefinition[]
	>;
	reviewContext: string;
	currentPlan: {
		tier: "FREE" | "PLUS" | "PREMIUM";
		interval: Subscription["interval"];
		status: Subscription["status"];
	} | null;
}
